import { useEffect } from 'react';
import { useStore } from '../services/store';

/**
 * Pushes store state into the AutoplayController.
 * Mounted once in the Widget root.
 */
const useAutoplayControllerSync = () => {
  const store = useStore();
  const controller = store.autoplayController;
  const medias = store.data?.content?.medias;
  const total = medias?.length ?? 0;
  const activePostIndex = total > 0
    ? (((store.currentPosition % total) + total) % total)
    : null;
  const enabled = store.data?.settings?.thumbnail_video_autoplay_hover ?? true;

  useEffect(() => { controller?.setEnabled(enabled); }, [controller, enabled]);
  useEffect(() => { controller?.setIsMobile(store.isMobile); }, [controller, store.isMobile]);
  useEffect(() => { controller?.setModalOpen(!!store.post); }, [controller, store.post]);
  useEffect(() => {
    controller?.setActivePostIndex(activePostIndex);
  }, [controller, activePostIndex]);
};

export default useAutoplayControllerSync;
